import CommandViewModel, { CommandListEntryType } from '../CommandViewModel';

import CommandComponent from './CommandComponent';

class SeparatorItem implements CommandComponent {
  public async serialize(): Promise<CommandViewModel> {
    return {
      type: CommandListEntryType.SEPARATOR,
    };
  }

  public find(): void | CommandComponent {
    return undefined;
  }
}

export default SeparatorItem;
